import React, { useEffect, useState } from "react";
import { ScrollText, Search } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Card, Loading, EmptyState, PageHeader, Badge } from "@/components/common";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try { const d = await api.get("/audit-log", q ? { q } : {}); setRows(d.rows || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { const t = setTimeout(load, q ? 350 : 0); return () => clearTimeout(t); /* eslint-disable-next-line */ }, [q]);

  return (
    <>
      <PageHeader title="Log Audit" subtitle={`${rows.length} entri`} icon={ScrollText} />
      <Card className="p-3 mb-4">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari user / alasan / record..." className="w-full h-10 pl-9 pr-3 rounded-xl border border-slate-300 outline-none focus:border-primary" data-testid="audit-search" />
        </div>
      </Card>
      {loading ? <Loading /> : !rows.length ? <EmptyState icon={ScrollText} title="Belum ada log" /> : (
        <Card className="overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-slate-400 border-b border-slate-100 bg-slate-50/50">
              <th className="py-3 px-4 font-medium">Waktu</th><th className="py-3 px-4 font-medium">User</th>
              <th className="py-3 px-4 font-medium">Modul</th><th className="py-3 px-4 font-medium">Aksi</th><th className="py-3 px-4 font-medium">Alasan</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-50">
                  <td className="py-3 px-4 text-slate-500 whitespace-nowrap">{fmtDateTime(r.created_at)}</td>
                  <td className="py-3 px-4 font-medium text-slate-800">{r.user_name || "-"}</td>
                  <td className="py-3 px-4"><Badge className="bg-slate-100 text-slate-600">{r.module_label || r.module}</Badge></td>
                  <td className="py-3 px-4 text-slate-600">{r.action}</td>
                  <td className="py-3 px-4 text-slate-400 text-xs max-w-xs truncate">{r.reason || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
